module.exports = __webpack_public_path__ + "static/24_PLATOS-PAN-SANCOCHO-D.6cf17814.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/24_PLATOS-PAN-SANCOCHO-D.png
// module id = 671
// module chunks = 35783957827783